import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { AlertService } from 'src/app/_services/alert.service';
import { ColDef, Column, ColumnApi, ColumnState, GridApi, GridOptions, GridReadyEvent, ITooltipParams, PaginationChangedEvent, RowClickedEvent } from 'ag-grid-community';
import { environment } from 'src/environments/environment';
const { defaultPageSizeArr, defaultPageSize } = environment;
import * as XLSX from 'xlsx';
import { SelectCellRenderer } from 'src/app/common/select-cell-renderer.component';
import { InputCellRenderer } from 'src/app/common/input-cell-renderer.component';
import { DatepickerCellRenderer } from 'src/app/common/datepicker-cell-renderer.component';
import { BtnCellRenderer } from 'src/app/common/button-cell-renderer.component';
import { DatepickerCellRenderer1 } from 'src/app/common/datepicker-cell-renderer.component1';
import { PaymentGatewayService } from '../payment-gateway-service';
import { InputCheckBoxFieldRenderer } from 'src/app/common/input-checkbox-field-renderer.component';

@Component({
  selector: 'app-tdr-setting',
  templateUrl: './tdr-setting.component.html',
  styleUrls: ['./tdr-setting.component.scss']
})
export class TdrSettingComponent implements OnInit {

 private systemAdmin : any = environment.adminUser;
 tdrForm!: FormGroup;
  merchants: any = [];
  acquirers: any = [];

  private gridApi!: GridApi;
  private gridColumnApi!: ColumnApi;
  public rowData: any = [];
  globalSearch: string = '';
  public defaultColDef: ColDef = {
    flex: 1,
    minWidth: 200,
    resizable: true,
    sortable: true,
    filter: false,
    autoHeight: true
  };

  collectionSize: number = 0;
  pageRecords: number = defaultPageSize;
  pageSizeArr: any = defaultPageSizeArr;
  pageNumber: number = 1;
  public gridOptions: GridOptions;

  public columnDefs: ColDef[] = [
    { field: 'payId', tooltipField: 'payId', hide: false, headerName: 'Pay ID', cellStyle: { textAlign: 'center' }, headerClass: 'center-header' },
    { field: 'currency', tooltipField: 'currency', hide: false, headerName: 'Currency', cellStyle: { textAlign: 'center' }, headerClass: 'center-header' },
    { field: 'acquirerName', tooltipField: 'acquirerName', hide: false, headerName: 'Acquirer', cellStyle: { textAlign: 'center' }, headerClass: 'center-header' },
    { field: 'paymentType', tooltipField: 'paymentType', hide: false, headerName: 'Payment Type', cellStyle: { textAlign: 'center' }, headerClass: 'center-header' },
    { field: 'mopType', tooltipField: 'mopType', hide: false, headerName: 'Mop Type', cellStyle: { textAlign: 'center' }, headerClass: 'center-header' },
    { field: 'minTransactionAmount', tooltipField: 'minTransactionAmount', hide: false, headerName: 'Min. Transaction Amount', cellRenderer: InputCellRenderer },
    { field: 'maxTransactionAmount', tooltipField: 'maxTransactionAmount', hide: false, headerName: 'Max. Transaction Amount', cellRenderer: InputCellRenderer },
    { field: 'fDate', tooltipField: 'fDate', hide: false, headerName: 'From Date', cellRenderer: DatepickerCellRenderer1 },
    { field: 'tDate', tooltipField: 'tDate', hide: false, headerName: 'To Date', cellRenderer: DatepickerCellRenderer1 },
    {
      field: 'bankPreference', lockVisible: true, hide: false, headerName: 'Bank Preference', cellRenderer: SelectCellRenderer, cellEditorParams: {
        options: [
          { value: 'FLAT', label: 'FLAT' },
          { value: 'PERCENTAGE', label: 'PERCENTAGE' },
        ]
      }, onCellValueChanged: (params: any) => {
        // const rowNode = this.gridApiSlab.getRowNode((params.node.rowIndex).toString());
        // if (rowNode) {
        //   this.slabData[params.node.rowIndex].markUpType = params.newValue;
        //   this.slabData[params.node.rowIndex]['isAmountDisabled'] = params.newValue === 'FLAT' ? false : true;
        //   this.slabData[params.node.rowIndex]['isAmountPercentDisabled'] = params.newValue === 'PERCENTAGE' ? false : true;
        //   rowNode.setDataValue('markUp', 0);
        //   rowNode.setDataValue('markUpPercentage', 0);
        // }
      }
    },
    { field: 'bankTdr', tooltipField: 'bankTdr', hide: false, headerName: 'Bank Tdr', cellRenderer: InputCellRenderer },
    { field: 'bankMinTdrAmt', tooltipField: 'bankMinTdrAmt', hide: false, headerName: 'Bank Min. Transaction Amount', cellRenderer: InputCellRenderer },
    { field: 'bankMaxTdrAmt', tooltipField: 'bankMaxTdrAmt', hide: false, headerName: 'Bank Max. Transaction Amount', cellRenderer: InputCellRenderer },
    {
      field: 'merchantPreference', lockVisible: true, hide: false, headerName: 'Merchant Preference', cellRenderer: SelectCellRenderer, cellEditorParams: {
        options: [
          { value: 'FLAT', label: 'FLAT' },
          { value: 'PERCENTAGE', label: 'PERCENTAGE' },
        ]
      }, onCellValueChanged: (params: any) => {
      }
    },
    { field: 'merchantTdr', tooltipField: 'merchantTdr', hide: false, headerName: 'Merchant Tdr', cellRenderer: InputCellRenderer },
    { field: 'merchantMinTdrAmt', tooltipField: 'merchantMinTdrAmt', hide: false, headerName: 'Merchant Min. Transaction Amount', cellRenderer: InputCellRenderer },
    { field: 'merchantMaxTdrAmt', tooltipField: 'merchantMaxTdrAmt', hide: false, headerName: 'Merchant Max. Transaction Amount', cellRenderer: InputCellRenderer },
    // { checkboxSelection: false, hide: false, headerName: 'Enable Surcharge', },
    {field: 'enableSurcharge',lockVisible:true,  headerName: 'Enable Surcharge', cellRenderer : InputCheckBoxFieldRenderer},

    
    { field: 'igst', tooltipField: 'igst', hide: false, headerName: 'VAT', cellRenderer: InputCellRenderer },
    {
      field: 'actions', headerName: 'Actions', width: 30, cellRenderer: BtnCellRenderer, cellRendererParams: [
        {
          clicked: async (event: any, param: any) => {
            this.onBtnClick(event, param, param.data.id)
          },
          buttonIconClass: 'icon-edit',
          buttonVisible: (params: any) => params.data.showEditButton
        },
        {
          clicked: async (event: any, param: any) => {
            this.editTdrSetting(event, param);
          },
          buttonIconClass: '',
          buttonText: 'Save',
          buttonVisible: (params: any) => params.data.showEditButton
        },
      ]
    }
  ];

  constructor(private _FB: FormBuilder, private _MBS: PaymentGatewayService, private alertService: AlertService) {
    this.gridOptions = <GridOptions>{};
  }

  ngOnInit(): void {
    // let email: string = localStorage.getItem('email')!;
    let email: string = this.systemAdmin;
    this.tdrForm = this._FB.group({
      merchantEmailId: [null, Validators.required],
      acquirer: [null, Validators.required],
      // currencyCode: [null, Validators.required],
      cardHolderType: [null, Validators.required],
      paymentRegion: [null, Validators.required],
      loggedInUserEmailId: [email]
    })
    this.getAllMerchants();
    this.tdrForm.valueChanges.subscribe(
      (data: any) => {
        if (this.tdrForm.valid) {
          this.getTdrSurchargeSettingList();
        }
      }
    )
  }

  getAllMerchants() {
    this._MBS.getAllMerchants().subscribe({
      next: (data: any) => {
        if (data && data.length) {
          this.merchants = data;
        } else {
          this.merchants = [];
        }
      },
      error: err => {
        this.alertService.toastErrorMessageAlert({
          title: err?.Message || 'Something went wrong!',
        });
      }
    });
  }

  getMappedAcquirer(eve: any) {
    this._MBS.getMappedAcquirer(eve).subscribe({
      next: (data: any) => {
        if (data && data.length) {
          this.acquirers = data.filter((_: any) => _ !== 'Select Acquirer');
        } else {
          this.acquirers = [];
        }
      },
      error: err => {
        this.alertService.toastErrorMessageAlert({
          title: err?.Message || 'Something went wrong!',
        });
      }
    });
  }

  currencyList: any = [];
  getCurrencyList(eve: any) {
    if (this.tdrForm.get('merchantEmailId')?.valid) {
      this._MBS.getCurrencyList(this.tdrForm.value.merchantEmailId, eve).subscribe({
        next: (data: any) => {
          if (data) {
            this.currencyList = Object.keys(data).map((_: any) => {
              return { code: _, name: data[_] }
            });
          } else {
            this.currencyList = [];
          }
        },
        error: err => {
          this.alertService.toastErrorMessageAlert({
            title: err?.Message || 'Something went wrong!',
          });
        }
      });
    }
  }

  tdrList: any;
  getTdrSurchargeSettingList() {
    this._MBS.getTdrSurchargeSettingList(this.tdrForm.value).subscribe({
      next: (data: any) => {
        if (data && data.status === "OK") {
          this.tdrList = Object.keys(data.payload.tdrSettingMap).map((_: any) => {
            data.payload.tdrSettingMap[_].map((__: any) => {
              __.showEditButton = true;
              __.isDatepickerDisabled = true;
              __.isSelectDisabled = true;
            })
            return { name: _, [_]: data.payload.tdrSettingMap[_] };
          });
        } else {
          this.tdrList = undefined;
        }
      },
      error: err => {
        this.alertService.toastErrorMessageAlert({
          title: err?.Message || 'Something went wrong!',
        });
      }
    });
  }

  onBtnClick(event: MouseEvent, params: any, id: string): void {
    params.data.showEditButton = !params.data.showEditButton;
    params.data.isSelectDisabled = !params.data.isSelectDisabled;
    params.data.isDatepickerDisabled = !params.data.isDatepickerDisabled;
    params.data.editFlag = !params.data.showEditButton;
    let indVal = this.tdrList.findIndex((_: any) => _.name === params.data.paymentType);
    const rowToUpdate = this.tdrList[indVal][params.data.paymentType].findIndex((row: any) => row.id === params.data.id); // Assume you want to update the second row
    const rowNode = this.gridOptions.api?.getRowNode(rowToUpdate.toString());
    if (rowNode) {
      const newData = { ...rowNode.data, showEditButton: params.data.showEditButton, isSelectDisabled: params.data.isSelectDisabled, isDatepickerDisabled: params.data.isDatepickerDisabled, editFlag: params.data.editFlag };
      rowNode.setData(newData);
      this.gridOptions.api?.refreshCells({ rowNodes: [rowNode], force: true });
    }
  }

  editTdrSetting(eve: any, param: any) {
    // let userType: string = localStorage.getItem('userType')!;
    let userType: string = "Admin";
    let obj = {
      tdr: {
        ...param.data
      },
      emailId: this.tdrForm.value.merchantEmailId,
      userType: userType,
      // loggedInUserEmailId: this.tdrForm.value.loggedInUserEmailId
      loggedInUserEmailId: this.systemAdmin
    }
    this._MBS.editTdrSurchargeSetting(obj).subscribe({
      next: (data: any) => {
        if (data && data.status === "OK") {
          this.onBtnClick(eve, param, param.data.id);
          this.alertService.toastSuccessMessageAlert({ title: data?.message || data?.Message || data?.response || data?.text });
          this.getTdrSurchargeSettingList();
        } else {
          this.alertService.toastWarringMessageAlert({ title: data?.message || data?.Message || data?.response || data?.text });
        }
      },
      error: err => {
        this.alertService.toastErrorMessageAlert({
          title: err?.Message || 'Something went wrong!',
        });
      }
    });
  }

  addRow() {

    // const newRow = { symbol: this.selectedCurrency, currencyName: this.selectedCurrency, country: this.selectedCountry, currentRate: 0.0, offeredRate: 0.0, fromAmount: 1, toAmount: 0, markUp: 0.0, markType: "PERCENTAGE", markUpPercentage: 0, effectiveDate: moment().format("MM-DD-YYYY HH:mm"), isAmountDisabled: false, isAmountPercentDisabled: true, fromCurrency: "AED", toCurrency: this.selectedCurrency, chargesType: this.selectedType };
    // this.slabData = [newRow, ...this.slabData];
    // this.gridApiSlab.setRowData(this.slabData);
  }

  removeRow() {

  }

}
